<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Asistencia de Empleados
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
   <v-row>
        <v-col cols="12" xs="8" sm="6" md="3" lg="3" xl="2">
          <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field outlined dense v-model="dateStart" label="Fecha de inicio" prepend-icon="mdi-calendar"
                readonly v-bind="attrs" v-on="on" ></v-text-field>
            </template>
            <v-date-picker v-model="dateStart" no-title scrollable :max="today" @input="menuStart = false"
              locale="es"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="8" sm="6" md="3" lg="3" xl="2">
          <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field outlined dense v-model="dateEnd" label="Fecha de fin" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" clearable></v-text-field>
            </template>
            <v-date-picker v-model="dateEnd" no-title scrollable :min="dateStart" @input="menuEnd = false"
              locale="es"></v-date-picker>
          </v-menu>
        </v-col>

      </v-row>
      <v-data-table
        :headers="headers"
        :items="asistencia"
        :search="search"
        class="elevation-1"
        :items-per-page="5"
      >
        <template v-slot:[`item.Tipo`]="{ item }">
          <v-chip :color="getStatusColor(item.Tipo)" dark>
            {{ item.Tipo === 0 ? 'Salida' :  item.Tipo === 1 ? 'Entrada' : ''}}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      headers: [
        { text: 'Id', value: 'Id' },
        { text: 'Nombre(s)', value: 'Nombres' },
        { text: 'Email', value: 'Email' },
        { text: 'Registro', value: 'FechaRegistroFormat' },
        { text: 'Hora de registro', value: 'HoraRegistroFormat' },
        { text: 'Tipo', value: 'Tipo' },
      ],
      asistencia:[],
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
             .toISOString()
             .substr(0, 10),
      dateEnd: null, // new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10), //(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menuStart: false,
      menuEnd: false,
      today:  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
             .toISOString()
             .substr(0, 10)
    };
  },
  created () {
    if (this.dateStart) {
      this.getAsistencia(this.dateStart);
    }
  },
  watch: {
    dateStart(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.getAsistencia(newVal);
      }
    },
    dateEnd(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.getAsistencia(this.dateStart, newVal);
      }
    }
  },
  methods: {
   getAsistencia (fecha, fechafin) {

    this.$http.get(`Asistencia?Fecha=${fecha}&FechaFin=${fechafin}`)
      .then(response => {
        if (response.status === 200) {
           this.asistencia = response.data
        }
      })
      .catch(() => {
      })
      .finally(() => {
      });
    },
    getStatusColor(status) {
      switch (status) {
        case 1:
          return 'green';
        case 2:
          return 'grey';
        default:
          return 'grey';
      }
    },
  },
};
</script>

<style scoped>
.v-data-table {
  font-size: 14px;
}
</style>
